import {
  Breadcrumb,
} from "@anchor/react-components/dist/lib/components";
import React, { useEffect, useMemo, useState } from "react";
import Transitions from "../../Components/PageTransitions/Transitions";
import MetaData from "../../Components/Metadata/MetaData";
import Onboarding from "../../Components/Onbaording/Onboarding";
import "./editPostmortem.css";
import Editors from "../../Components/Editors/Editors";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Col, Row } from "react-bootstrap";

import Loading from "../../Components/Loading";
import { UseEditPostmortems } from ".";
import NotAuthorised from "../../Components/NotAuthorised/NotAuthorised";
import {
  McButton,
  McCheckbox,
  McInput,
  McStepIndicator,
} from "@maersk-global/mds-react-wrapper/components-core";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { PostmortemServices } from "../../services/postmortemServices";
import { postmortemApiEndpoint } from "../../config";
import errorNotification from "../../Components/Notification/errorNotification";
import successNotification from "../../Components/Notification/successNotification";
import uploadInitiatedNotification from "../../Components/Notification/uploadInitiatedNotification";
import UserPickerSelect from "../../Components/UserPickerSelect";
import { fetchMttrInsights } from "../../services/mttrInsightsService";
import { useQueryClient } from "react-query";
import { cachedRequest } from "../../Utils/cachedRequest";
import UsePostmortemInfo from "../../context/PostmortemContext";

function EditPostmortems() {
  const {
    currentStep,
    pmtId,
    incidentID,
    problemID,
    priority,
    createdOn,
    cmdb_ci,
    assigned_to,
    state,
    navigateTo,
    loadingData,
    userIsAdmin,
    userAccessData,
    error,
    owningBusinessUnitUser,
    steps,
    setSteps,
    mimStateRef,
    MarkThisPostmortemInComplete,
    HandleCloseWithoutLTReview,
    HandleEDSignOff,
    HandleVendorSignOff,
    userIsAMimMember,
    callerId,
    postmortemIsInComplete,
    closedWithoutLTReview,
    edSignedOff,
    vendorSignedOff,
    causedByVendor,
    edName,
    setEdName,
    edSignedOffBy,
    vendorSignedOffBy,
    closedWithoutLTReviewBy,
    incompleteMarkedBy,
    channelName,
    userIsApmtMember,
    smData,
    handleGenerateRCAOnDemand,
    generatingRCA,
    canGenerateRCA,
    showEDSignOff,
    showVendorSignOff,
    editLockStatus,
    editLockedBy,
    editLockedByName,
    showLockExpiryWarning,
    lockExpiryCountdown,
    extendEditLock,
    handleReleaseLock,
    setCurrentPostmortemObject,
    currentPostmortemObject,
  } = UseEditPostmortems();

  const { postmortemState } = UsePostmortemInfo();
  const { instance, accounts } = useMsal();
  const accountId = accounts[0]?.homeAccountId;
  const queryClient = useQueryClient();
  const { postPostMortemData,  } = PostmortemServices();
  const apiEndpoint = postmortemApiEndpoint;
  const [currentPriority, setCurrentPriority] = useState(priority);
  const [currentAssignedTo, setCurrentAssignedTo] = useState(assigned_to);
  const [mttrInsights, setMttrInsights] = useState(null);
  const [recipientsRefreshTick, setRecipientsRefreshTick] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (!incidentID || !accountId) return;
    cachedRequest(queryClient, ["mttrInsights", incidentID], () => fetchMttrInsights(incidentID, instance, accounts))
      .then((data) => { if (data) setMttrInsights(data); })
      .catch(() => {});
  }, [incidentID, instance, accountId]);

  const kpiMttd = mttrInsights?.ttd_seconds != null
    ? parseFloat(mttrInsights.ttd_seconds) / 60
    : currentPostmortemObject?.detectionResponse?.mttd;
  const kpiMttr = mttrInsights?.ttr_seconds != null
    ? parseFloat(mttrInsights.ttr_seconds) / 60
    : currentPostmortemObject?.detectionResponse?.mttrecover;

  useEffect(() => {
    setCurrentPriority(priority);
  }, [priority]);

  useEffect(() => {
    setCurrentAssignedTo(assigned_to);
  }, [assigned_to]);


  const handlePriorityChange = async (newPriority) => {
    if (!newPriority || newPriority === currentPriority) return;

    setCurrentPriority(newPriority);

    const updatedPostmortem = {
      incidentID,
      priority: String(newPriority),
    };

    try {
      uploadInitiatedNotification();
      const userInfo =
        accounts[0]?.username ||
        accounts[0]?.name ||
        accounts[0]?.preferred_username ||
        accounts[0]?.idTokenClaims?.preferred_username ||
        accounts[0]?.idTokenClaims?.name ||
        accounts[0]?.localAccountId ||
        "unknown";

      const apiResponse = await postPostMortemData(
        apiEndpoint,
        incidentID,
        updatedPostmortem,
        { "X-User": userInfo }
      );

      if (apiResponse.status === 200 || apiResponse.status === 201) {
        // Update currentPostmortemObject to reflect the change locally
        setCurrentPostmortemObject(prev => ({
          ...prev,
          priority: String(newPriority)
        }));
        successNotification("Priority updated successfully");
      } else {
        throw new Error("Unknown error");
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        errorNotification("Please reload the page");
        sessionStorage.clear();
      } else {
        errorNotification(
          "Error updating priority: " + (error.message || "Unknown error")
        );
      }
      setCurrentPriority(priority);
    }
  };

  const handleAssignedToChange = async (newAssignedTo) => {
    // Capture previous value before updating state
    const previousValue = currentAssignedTo;
    setCurrentAssignedTo(newAssignedTo);
    
    // Debounce the save - only save after user stops typing for 1 second
    if (window.assignedToSaveTimeout) {
      clearTimeout(window.assignedToSaveTimeout);
    }
    
    window.assignedToSaveTimeout = setTimeout(async () => {
      // Compare against previous local state value, not the prop
      if (newAssignedTo === previousValue) {
        return; // No change, skip save
      }

      console.log('Saving assigned_to from:', previousValue, 'to:', newAssignedTo);
      
      // Create updated postmortem object
      const updatedPostmortem = {
        incidentID,
        assigned_to: newAssignedTo,
      };

      try {
        uploadInitiatedNotification();
        const userInfo = accounts[0]?.username || 
                       accounts[0]?.name || 
                       accounts[0]?.preferred_username ||
                       accounts[0]?.idTokenClaims?.preferred_username ||
                       accounts[0]?.idTokenClaims?.name ||
                       accounts[0]?.localAccountId ||
                       "unknown";

        const apiResponse = await postPostMortemData(
          apiEndpoint,
          incidentID,
          updatedPostmortem,
          { "X-User": userInfo }
        );

        if (apiResponse.status === 200 || apiResponse.status === 201) {
          // Update currentPostmortemObject to reflect the change locally
          setCurrentPostmortemObject(prev => ({
            ...prev,
            assigned_to: newAssignedTo
          }));
          successNotification("Assigned To updated successfully");
        } else {
          throw new Error("Unknown error");
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          errorNotification("Please reload the page");
          sessionStorage.clear();
        } else {
          errorNotification(
            "Error updating Assigned To: " + (error.message || "Unknown error")
          );
        }
        setCurrentAssignedTo(previousValue);
      }
    }, 1000);
  };


  const goToHistoryPage = (path) => {
    navigate(path);
  };

  useEffect(() => {
    if (priority && (priority === "3" || priority === "4")) {
      let currentSteps = [...steps];
      currentSteps.splice(4, 1);
      setSteps(currentSteps);
    }
  }, [priority]);

  const isP3orP4 = priority === "3" || priority === "4";

  const statusLabels = useMemo(() => {
    if (isP3orP4) {
      return ["PENDING RCA", "LEADERSHIP REVIEW", "Completed"];
    }
    return ["PENDING RCA", "LEADERSHIP REVIEW", "Completed"];
  }, [isP3orP4]);

  const userIsAuthorizedToEdit = (pmtId, priority, owningBusinessUnit) => {
    if (userIsAdmin) return true;
    if ((priority === "3" || priority === "4") && userIsAMimMember) return true;
    return userAccessData?.some((data) => data.postMortemId === pmtId);
  };

  if (error) throw error;

  if (loadingData || editLockStatus === "checking") {
    return (
      <div>
        <Loading />
      </div>
    );
  }

  // Session expired
  if (editLockStatus === "expired") {
    return (
      <Transitions>
        <main className="main-postmrtm-1">
          <ToastContainer />
          <div className="edit-lock-container">
            <div className="edit-lock-card">
              <div className="edit-lock-icon">⏱️</div>
              <h4 className="edit-lock-title">Edit Session Expired</h4>
              <p className="edit-lock-body">
                Your editing session has expired due to inactivity. The
                postmortem has been unlocked for others to edit.
              </p>
              <div className="edit-lock-actions">
                <McButton
                  appearance="primary"
                  click={() => window.location.reload()}
                >
                  Re-open Edit Page
                </McButton>
                <McButton
                  appearance="neutral"
                  variant="outlined"
                  click={() => navigate("/ongoing-postmortems")}
                >
                  ← Back to Ongoing Postmortems
                </McButton>
              </div>
            </div>
          </div>
        </main>
      </Transitions>
    );
  }

  // Blocked by another user's lock
  if (editLockStatus === "locked") {
    return (
      <Transitions>
        <main className="main-postmrtm-1">
          <ToastContainer />
          <div style={{ width: "100%" }}>
            <Row>
              <Col xxl={3}>
                <Breadcrumb
                  activeItem="editProfile"
                  className="breadcrumb-story"
                  mainObject={{
                    editProfile: {
                      breadcrumbLocator: "home.profile.editProfile",
                      label: "Edit Postmortem",
                      path: `postmortems/editpostmortem/${pmtId}`,
                    },
                    home: {
                      breadcrumbLocator: "home",
                      label: "Home",
                      path: "/",
                    },
                    profile: {
                      breadcrumbLocator: "home.profile",
                      label: "Ongoing Postmortems",
                      path: "/ongoing-postmortems",
                    },
                  }}
                  onBreadcrumbClick={navigateTo}
                  separator="/"
                />
              </Col>
            </Row>
          </div>
          <div className="edit-lock-container">
            <div className="edit-lock-card">
              <div className="edit-lock-icon">🔒</div>
              <h4 className="edit-lock-title">Edit Access Locked</h4>
              <p className="edit-lock-body">
                This postmortem is currently being edited by{" "}
                <strong>{editLockedByName || editLockedBy}</strong>.
              </p>
              <p className="edit-lock-sub">
                The edit session will automatically expire in 10 minutes.
                Please try again later.
              </p>
              <div className="edit-lock-actions">
                <McButton
                  appearance="primary"
                  click={() => navigate("/ongoing-postmortems")}
                >
                  ← Back to Ongoing Postmortems
                </McButton>
              </div>
            </div>
          </div>
        </main>
      </Transitions>
    );
  }

  if (true) {
    return (
      <>
        <Transitions>
          <main className="main-postmrtm-1">
            <ToastContainer />

            {/* ── Breadcrumb ───────────────────── */}
            <Breadcrumb
              activeItem="editProfile"
              className="breadcrumb-story"
              mainObject={{
                editProfile: {
                  breadcrumbLocator: "home.profile.editProfile",
                  label: "Edit Postmortem",
                  path: `postmortems/editpostmortem/${pmtId}`,
                },
                home: {
                  breadcrumbLocator: "home",
                  label: "Home",
                  path: "/",
                },
                profile: {
                  breadcrumbLocator: "home.profile",
                  label: "Ongoing Postmortems",
                  path: "/ongoing-postmortems",
                },
              }}
              onBreadcrumbClick={navigateTo}
              separator="/"
            />

            {/* ── Metadata ──────────────────────── */}
            <div className="metaData_wrapper">
              <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "stretch" }}>
                <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                  <MetaData
                    incidentID={incidentID}
                    short_description={currentPostmortemObject?.short_description}
                    problemID={problemID}
                    priority={currentPriority}
                    createdOn={createdOn}
                    cmdb_ci={cmdb_ci}
                    assigned_to={currentAssignedTo}
                    state={postmortemIsInComplete || state}
                    owningBusinessUnit={owningBusinessUnitUser}
                    caller_id={callerId}
                    channelName={channelName}
                    smData={smData}
                    priorityEditable={true}
                    onPriorityChange={handlePriorityChange}
                    assignedToEditable={true}
                    onAssignedToChange={handleAssignedToChange}
                    mttd={kpiMttd}
                    mttrecover={kpiMttr}
                    impactedByChange={currentPostmortemObject?.rootCause?.impactedByChange}
                    postMortemId={pmtId}
                    portfolio={postmortemState?.portfolio?.value}
                    platform={postmortemState?.platform?.value}
                    isDraft={postmortemState?.postmortemCurrentStatus?.currentState === "DRAFT"}
                    recipientsRefreshTick={recipientsRefreshTick}
                  />
                </div>
                <div className="onboardingWrapper fourth-step" style={{ display: "flex", flexDirection: "column" }}>
                  <Onboarding />
                </div>
              </div>
            </div>

            {/* ── Status stepper ────────────────── */}
            {!postmortemIsInComplete && (
              <div className="edit-status-stepper second-step">
                <McStepIndicator
                  labels={statusLabels}
                  currentindex={currentStep}
                  orientation="horizontal"
                  fit="small"
                  autolayoutdisabled={true}
                  alignitemsdisabled={true}
                />
              </div>
            )}

            {/* ── Admin action bar ──────────────── */}
            {userIsAdmin && (
              <div className="edit-action-bar">
                {/* Actions group */}
                <div className="edit-action-group">
                  <div className="edit-action-group-row">
                    <McButton
                      appearance="neutral"
                      variant="outlined"
                      click={() =>
                        goToHistoryPage(
                          `/change-history?incidentId=${incidentID}&PostMortemId=${pmtId}`
                        )
                      }
                    >
                      Audit History
                    </McButton>
                    {canGenerateRCA && (
                      <McButton
                        appearance="primary"
                        disabled={generatingRCA}
                        click={handleGenerateRCAOnDemand}
                      >
                        {generatingRCA ? "Generating..." : "Generate AI RCA"}
                      </McButton>
                    )}
                  </div>
                </div>

                {/* Status flags group */}
                {(postmortemIsInComplete || closedWithoutLTReview || userIsAdmin) && (
                  <div className="edit-action-group">
                    <p className="edit-action-group-label">Status Flags</p>
                    <div className="edit-action-group-row">
                      {(postmortemIsInComplete || userIsAdmin) && (
                        <div>
                          <McCheckbox
                            label="Mark as Incomplete"
                            name="disclaimer"
                            click={console.log("saving")}
                            change={MarkThisPostmortemInComplete}
                            focus={console.log("saving")}
                            blur={console.log("saving")}
                            disabled={!userIsAdmin || closedWithoutLTReview}
                            checked={postmortemIsInComplete}
                          />
                          {postmortemIsInComplete && incompleteMarkedBy && (
                            <p className="edit-action-group-meta">
                              Marked by {incompleteMarkedBy}
                            </p>
                          )}
                        </div>
                      )}
                      {(closedWithoutLTReview || userIsAdmin) && (
                        <div>
                          <McCheckbox
                            label="Close without TLT Review"
                            name="closeWithoutLTReview"
                            click={console.log("saving")}
                            change={HandleCloseWithoutLTReview}
                            focus={console.log("saving")}
                            blur={console.log("saving")}
                            disabled={!userIsAdmin || postmortemIsInComplete}
                            checked={closedWithoutLTReview}
                          />
                          {closedWithoutLTReview && closedWithoutLTReviewBy && (
                            <p className="edit-action-group-meta">
                              Closed by {closedWithoutLTReviewBy}
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* ED Sign-off group */}
                {showEDSignOff && (
                  <div className="edit-action-group">
                    <p className="edit-action-group-label">ED Sign-off</p>
                    <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                      <div style={{ display: "flex", alignItems: "flex-start", gap: "12px", flexWrap: "nowrap" }}>
                        <div style={{ minWidth: "250px", flexShrink: 0 }}>
                          <UserPickerSelect
                            value={edName}
                            onChange={(email, displayName) => setEdName(email)}
                            placeholder="Type ED name..."
                            disabled={!userIsAdmin}
                            required
                          />
                        </div>
                        <div style={{ marginTop: "8px", whiteSpace: "nowrap", flexShrink: 0 }}>
                          <McCheckbox
                            label="ED Acknowledgment"
                            name="edSignOff"
                            click={console.log("saving")}
                            change={HandleEDSignOff}
                            focus={console.log("saving")}
                            blur={console.log("saving")}
                            style={{ fontSize: "14px" }}
                            disabled={!userIsAdmin}
                            checked={edSignedOff}
                          />
                        </div>
                      </div>
                    </div>
                    {edSignedOff && edSignedOffBy && (
                      <p className="edit-action-group-meta">
                        Acknowledged by {edSignedOffBy}
                      </p>
                    )}
                  </div>
                )}

                {/* Vendor group */}
                {showVendorSignOff && (
                  <div className="edit-action-group">
                    <p className="edit-action-group-label">Vendor-Caused</p>
                    <div className="edit-action-group-row">
                      <McCheckbox
                        label="Mark as Vendor-Caused"
                        name="vendorSignOff"
                        click={console.log("saving")}
                        change={HandleVendorSignOff}
                        focus={console.log("saving")}
                        blur={console.log("saving")}
                        disabled={!userIsAdmin}
                        checked={vendorSignedOff}
                      />
                    </div>
                    {vendorSignedOff && vendorSignedOffBy && (
                      <p className="edit-action-group-meta">
                        Marked by {vendorSignedOffBy}
                      </p>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* ── Form editors ──────────────────── */}
            <div style={{ marginTop: "8px", padding: "0 4px" }}>
              <Editors
                incidentID={incidentID}
                postmortemID={pmtId}
                incomplete={postmortemIsInComplete}
                edSignedOff={edSignedOff}
                onSaveComplete={() => setRecipientsRefreshTick((t) => t + 1)}
              />
            </div>

            {/* ── Lock expiry overlay ────────────── */}
            {showLockExpiryWarning && (
              <div className="edit-lock-expiry-overlay">
                <div className="edit-lock-expiry-dialog">
                  <div className="edit-lock-expiry-icon">⚠️</div>
                  <h4 className="edit-lock-title">Edit Session Expiring Soon</h4>
                  <p className="edit-lock-body">
                    Your edit lock will expire in{" "}
                    <strong
                      className={`edit-lock-countdown ${
                        lockExpiryCountdown <= 10 ? "urgent" : "warn"
                      }`}
                    >
                      {lockExpiryCountdown}s
                    </strong>
                    .
                  </p>
                  <p className="edit-lock-sub">
                    Click <strong>Keep Editing</strong> to extend your session,
                    or your lock will be released automatically.
                  </p>
                  <div className="edit-lock-actions">
                    <McButton appearance="primary" click={extendEditLock}>
                      Keep Editing
                    </McButton>
                    <McButton
                      appearance="neutral"
                      variant="outlined"
                      click={handleReleaseLock}
                    >
                      Release &amp; Exit
                    </McButton>
                  </div>
                </div>
              </div>
            )}
          </main>
        </Transitions>
      </>
    );
  } else {
    return <NotAuthorised />;
  }
}

export default EditPostmortems;
